export default __webpack_public_path__ + "static/media/fire-ball.a15a5d8c.png";